<template>
<b-form @submit="save" name="profile-form">
    <b-row class="m-2">
        <b-col cols="12">
            <b-row>
                <b-col>
                    <h1>
                        Edit Rule
                    </h1>
                </b-col>
                <b-col class="text-right OTbtnContainer ">
                    <otif-button type="button" class=" OTSecondary" @click.native="$router.push({name: 'pipeline-activation-rules-list'})">Cancel</otif-button>
                    <otif-button type="submit" class=" OTPrimary" id="OTSaveSetting">Save</otif-button>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
    <b-row class="m-2">
        <b-col cols="6">
            <otif-textInput
                label="Rule Name"
                v-model="rule.ruleName"
                name="name"
                :required="true"
                />
        </b-col>
    </b-row>
    <b-row class="m-2">
        <b-col cols="6">
            <otif-select
                label="Operator"
                v-model="rule.ruleOperator"
                :values="operators"
                name="operator"/>
        </b-col>
    </b-row>
    <b-row class="m-2">
        <otif-table
            :validations="tableValidations"
            :rows="conditionRows"
            :columns="columns"
            @change="onConditionsChange"/>
    </b-row>
</b-form>
</template>

<script>

import axios from 'axios';
import OperatorColumn from './table/OperatorColumn.vue';
import NoSpaceEditColumn from './table/NoSpaceEditColumn.vue';

export default {
    data() {
        return {
            tableValidations: {
                conditionName: {
                    validName(e) {
                        return /^[\w\-\.]+$/gi.test(e);
                    }
                }
            },
            columns: [{
                name: 'conditionName',
                label: 'Name',
                invalidMessage: 'Can only contain alphanumeric characters'
            },{
                name: 'metadata-fn',
                label: 'Metadata Field Name'
            },{
                name: 'location',
                label: 'Location'
            },{
                name: 'operator',
                label: 'Operator',
                editComponent: OperatorColumn
            },{
                name: 'value',
                label: 'Value'
            }],
            rule: {
                conditions: [],
                ruleId: '',
                ruleName: '',
                ruleOperator: '',
                version: 0
            },
            operators: [
                'OR', 'AND', 'NOT'
            ],
            conditionRows: []
        }
    },

    props: ['ruleId'],

    methods: {
        onConditionsChange(e) {
            console.log(e);
            this.rule.conditions = e.rows.map((row) => {
                return {
                    name: row[0],
                    fieldName: row[1],
                    location: row[2],
                    operator: row[3],
                    value: row[4]
                }
            });
        },

        onSubmit(e) {
            e.preventDefault();
        },

        async save(e) {
            e.preventDefault();

            this.$snotify.info('Saving Rule ...', {timeout: 0});

            try {
                const res = await axios.put('/mtm-gateway-api/v1/services/pipeline/activation-rules/' + this.ruleId, this.rule);
                this.rule = res.data;
                this.$snotify.clear();
                this.$snotify.success('Rule saved');
            } catch (e) {
                console.error(e);
                this.$snotify.clear();
                this.$snotify.error('There was an error trying to save the rule');
            }
        },

        async load() {

            const res = await axios.get('/mtm-gateway-api/v1/services/pipeline/activation-rules/' + this.ruleId);
            this.rule = res.data;
            this.conditionRows = this.rule.conditions.map((cond) => {
                return [cond.name, cond.fieldName, cond.location, cond.operator, cond.value]
            });
        }
    },

    created() {
        this.load();
    }
}

</script>